export default __webpack_public_path__ + "static/media/resume-1.8b37eab9.png";